import { render } from "./IconLive.vue?vue&type=template&id=afc9f12a&ts=true"
import script from "./IconLive.vue?vue&type=script&lang=ts"
export * from "./IconLive.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__